import React from "react";
import { motion } from "framer-motion";

const OurRecruiters = () => {
  const Recruiters = [
    { img: "/images/recruiters/001_1.jpg", key: "1" },
    { img: "/images/recruiters/002_2.jpg", key: "2" },
    { img: "/images/recruiters/003_1.jpg", key: "3" },
    { img: "/images/recruiters/004_1.jpg", key: "4" },
    { img: "/images/recruiters/005_2.jpg", key: "5" },
    { img: "/images/recruiters/Jaro_Education_Logo.png", key: "6" },
    { img: "/images/recruiters/Toppr_logo.png", key: "7" },
    { img: "/images/recruiters/006_2.jpg", key: "8" },
    { img: "/images/recruiters/007_2.jpg", key: "9" },
    { img: "/images/recruiters/logo-infosys.png", key: "10" },
    { img: "/images/recruiters/008_2.jpg", key: "11" },
    { img: "/images/recruiters/009_1.jpg", key: "12" },
    { img: "/images/recruiters/010_1.jpg", key: "13" },
    { img: "/images/recruiters/011_2.jpg", key: "14" },
    { img: "/images/recruiters/012_1.jpg", key: "15" },
    { img: "/images/recruiters/Wipro_Primary_Logo_Color.png", key: "16" },
    { img: "/images/recruiters/013_2.jpg", key: "17" },
    { img: "/images/recruiters/netsmartz.png", key: "18" },
    { img: "/images/recruiters/014_2.jpg", key: "19" },
    { img: "/images/recruiters/015_2.jpg", key: "20" },
    { img: "/images/recruiters/IIT.png", key: "21" },
    { img: "/images/recruiters/KREATIVAN.png", key: "22" },
    { img: "/images/recruiters/pims.png", key: "23" },
    { img: "/images/recruiters/RADISSON.jpg", key: "24" },
    { img: "/images/recruiters/sensational.jpg", key: "25" },
    { img: "/images/recruiters/ZAPBUILD.png", key: "26" },
    { img: "/images/recruiters/wipro logo.jpg", key: "27" },
    { img: "/images/recruiters/WESTLINE.png", key: "28" },
    { img: "/images/recruiters/TRAYA LOGO.webp", key: "29" },
    { img: "/images/recruiters/TOPPR.png", key: "30" },
    { img: "/images/recruiters/THINKNEXT.png", key: "31" },
    { img: "/images/recruiters/tech cadd.png", key: "32" },
    { img: "/images/recruiters/TCS LOGO.jfif", key: "33" },
    { img: "/images/recruiters/SUKHJIT STACH MILL.png", key: "34" },
    { img: "/images/recruiters/SOLITAIRE.png", key: "35" },
    { img: "/images/recruiters/smart enterprises.png", key: "36" },
    { img: "/images/recruiters/SKOPE TELECOM.jpg", key: "37" },
    { img: "/images/recruiters/shrimann.jpg", key: "38" },
    { img: "/images/recruiters/sensational logo (1).jpg", key: "39" },
    { img: "/images/recruiters/SEBIZ.jfif", key: "40" },
    { img: "/images/recruiters/Seasia_logo.png", key: "41" },
    { img: "/images/recruiters/SACH TECH SOLUTIONS.png", key: "42" },
    { img: "/images/recruiters/RESEARCH WIRE.png", key: "43" },
    { img: "/images/recruiters/relinns.png", key: "44" },
    { img: "/images/recruiters/RED HAT.png", key: "45" },
    { img: "/images/recruiters/RADSOL.png", key: "46" },
    { img: "/images/recruiters/pisoft.jfif", key: "47" },
    { img: "/images/recruiters/Nugen-Logo-11-version (1).cdr", key: "48" },
    { img: "/images/recruiters/NIMBLE.jfif", key: "49" },
    { img: "/images/recruiters/netsmartz.png", key: "50" },
    { img: "/images/recruiters/net solution logo.png", key: "51" },
    { img: "/images/recruiters/mphasis-logo-png-thumb-1010.gif", key: "52" },
    { img: "/images/recruiters/logo sach tech.png", key: "53" },
    { img: "/images/recruiters/ITRONIX.png", key: "54" },
    { img: "/images/recruiters/INFOSYS NAVIGATE LOGO.png", key: "55" },
    { img: "/images/recruiters/IMPINGE.jfif", key: "57" },
    { img: "/images/recruiters/IBM.png", key: "58" },
    { img: "/images/recruiters/IBM logo.png", key: "59" },
    { img: "/images/recruiters/HP.png", key: "60" },
    { img: "/images/recruiters/hike.png", key: "61" },
    { img: "/images/recruiters/GNA.png", key: "62" },
    { img: "/images/recruiters/ginger logo.png", key: "63" },
    { img: "/images/recruiters/bed rock.png", key: "64" },
    { img: "/images/recruiters/bebo logo.jfif", key: "65" },
    { img: "/images/recruiters/B (6).jpg", key: "66" },
    { img: "/images/recruiters/B (5).jpg", key: "67" },
    { img: "/images/recruiters/B (4).png", key: "68" },
    { img: "/images/recruiters/B (4).jpg", key: "69" },
    { img: "/images/recruiters/B (3).png", key: "70" },
    { img: "/images/recruiters/B (3).jpg", key: "71" },
    { img: "/images/recruiters/B (2).png", key: "72" },
    { img: "/images/recruiters/B (1).png", key: "73" },
    { img: "/images/recruiters/B (1).jpg", key: "74" },
    { img: "/images/recruiters/ARABOL.jpg", key: "75" },
    { img: "/images/recruiters/aosc.png", key: "76" },
    { img: "/images/recruiters/AMAZON AWS.png", key: "77" },
    { img: "/images/recruiters/ADVANCE SOLUTIONS.png", key: "78" },
    { img: "/images/recruiters/A 13 (3).png", key: "79" },
    { img: "/images/recruiters/A 13 (3).jpg", key: "80" },
    { img: "/images/recruiters/A 13 (2).png", key: "81" },
    { img: "/images/recruiters/A 13 (2).jpg", key: "82" },
  ];
  return (
    <div>
      <motion.div
        initial={{ opacity: 0, translateY: +60 }}
        whileInView={{ opacity: 1, translateY: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        key="modal"
      >
        <div className="mt-20 ml-3 flex justify-center pb-10 text-3xl font-bold md:text-5xl">
          <motion.div
            initial={{ opacity: 0, translateY: +60 }}
            whileInView={{ opacity: 1, translateY: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            key="modal"
          >
            <h1 className=" border-l-4 border-[#32727A] pl-10 xs:pl-4  text-[#081C3A]">
              Our <span className="pl-1 text-[#32727A]">Recruiters</span>
            </h1>
          </motion.div>
        </div>
      </motion.div>
      <div className="marquee h-[200px]">
        <div className="marquee--inner ">
          <div className="flex gap-x-10  ">
            {Recruiters.map((item) => (
              <div
                key={item?.key}
                className="mspan h-[80px] w-[150px] border-8 border-white  shadow-lg  md:h-[110px] md:w-[200px] "
              >
                <img
                  src={item.img}
                  alt=""
                  className="rounded-full lg:rounded-none"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurRecruiters;
